import { Component, inject, signal } from '@angular/core';
import { MegaMenuItem } from 'primeng/api';
import { DashboardNavbarFacade } from 'src/app/facades/dashboard-navbar.facade';

@Component({
	standalone: false,
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss'],
	providers: [DashboardNavbarFacade],
})
export class NavbarComponent {
	private readonly facade = inject(DashboardNavbarFacade);

	readonly items = signal<MegaMenuItem[]>([
		{
			id: 'logout',
			label: 'Logout',
			icon: 'pi pi-fw pi-sign-in',
			command: () => this.onLogoutClick(),
		},
	]);

	onMenuClick(e: { item: { id?: string } }): void {
		this.facade.onMenuClick(e?.item?.id);
	}

	onLogoutClick(): void {
		this.facade.onLogoutClick();
		this.items.set([]);
	}

	closeItem(event: Event, index: number): void {
		event.preventDefault();
		this.items.update(list => {
			const next = [...list];
			next.splice(index, 1);
			return next;
		});
	}
}
